import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import styled from 'styled-components'

import colors from 'components/utils/colors'

import Select from 'components/Shared/Select/Index'
import FilterTitle from './FilterTitle'

const PORTAL_Z_INDEX = 10001

const StyledWrapper = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: 1px solid ${colors.secondary70};
`

const StyledSelect = styled(Select)`
  && {
    margin: 0 10px 10px 9px;
    width: auto;
    min-height: 30px;
    max-height: fit-content;
    font-size: 14px;
  }
`

const FilterSectionMultiSelect = ({
  title, name, value, onChange, options, iconComponentsMap,
}) => {
  const active = value.length > 0
  const [value_, setValue_] = useState(value)
  const isEmpty = Boolean(!value_.length)

  useEffect(() => {
    setValue_(value)
  }, [value])

  const onActiveChange = (newActive) => {
    applyChanges(newActive ? value_ : [])
  }

  const onInputChange = (newValue) => {
    setValue_(newValue)
    if (active) {
      applyChanges(newValue)
    }
  }

  const applyChanges = (newValue) => {
    onChange?.({
      value: newValue,
      name: name,
    })
  }

  // use portal to prevent cropping options list horizontally
  return (
    <StyledWrapper data-test={name}>
      <FilterTitle
        disabled={isEmpty}
        active={active}
        title={title}
        onActiveChange={onActiveChange}
      />
      <StyledSelect
        multiselect
        small
        value={value_}
        onChange={onInputChange}
        options={options}
        iconComponentsMap={iconComponentsMap}
        usePortal
        portalZindex={PORTAL_Z_INDEX}
      />
    </StyledWrapper>
  )
}

FilterSectionMultiSelect.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  iconComponentsMap: PropTypes.object,
}

export default FilterSectionMultiSelect
